// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2GCq9","header":"MessagesList_header__dAIhH","chat":"MessagesList_chat__3yuhM"};